module.exports = __webpack_public_path__ + "img/madden_twitter-competition.cd1f04d1.png";